/* global google */

import { BaseService } from "./baseService";

class AuthService extends BaseService {
    /**
     * @param $http
     * @param $window
     * @param $mdDialog
     */
    constructor($http, $window, $q, $mdDialog) {
        super($http);
        this.$window = $window;
        this.$q = $q;
        this.dialog = $mdDialog;
        this.client = null;
        this.token = false;
    }

    getClientId() {
        return window.location.origin === 'https://tool.kokoa.io' ?
          '810584665104-b14ds8tbaeve3pkc0vph2me62i9lv18j.apps.googleusercontent.com' : //prod application
          '644687684119-e0q0dqrad0i9bp8rn108m93ljd5ssieg.apps.googleusercontent.com'; //dev application
    }

    init(google, type, token) {
        this.client = google.accounts.oauth2.initCodeClient({
            client_id: this.getClientId(),
            prompt: '',
            redirect_uri: 'postmessage',
            ux_mode: 'popup',
            scope: 'https://www.googleapis.com/auth/drive',
            callback: (res) => {
                if (res) {
                    if (this.token) {
                        return this.register({token: this.token, googleAccessToken: res.code}).then(() => this.$window.location.href = '/login?accepted=1');
                    } else {
                        return this.loginWithGoogle(res);
                    }
                }
            }
        });
        google.accounts.id.initialize({
            client_id: this.getClientId(),
            callback: () => {
                if (type === 'login') {
                  this.loginOrRegister(true)
                } else if (type === 'register') {
                  this.loginOrRegister(true, null, token);
                }}
          });
          google.accounts.id.renderButton(
            document.getElementById("google-button"),
            { theme: "outline", size: "large"}
          );
    }

    userIsNotAuthenticated = function() {
        return !localStorage.getItem('kes_email') ||
            localStorage.getItem('kes_email') === 'undefined' ||
            !localStorage.getItem('kes_token') ||
            localStorage.getItem('kes_token') === 'undefined'
    };

    checkToken(token) {
        let self = this;
        return this.$http({
            method: 'GET',
            url: this.getRoot() + '/user/confirmation/' + token,
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token')
            },
            data: {},
        }).then((response) => response.data, error => self.$q.reject(error));
    }

    register(data) {
        let self = this;
        return this.$http({
            method: 'POST',
            url: this.getRoot() + '/user/confirmation',
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token')
            },
            data: data,
        }).then((response) => response.data, error => self.$q.reject(error));
    }

    forgotPassword(email) {
        let self = this;
        return this.$http({
            method: 'POST',
            url: this.getRoot() + '/user/forgot-password',
            headers: {
                'Content-Type': 'application/json'
            },
            data: { email: email }
        }).then((response) => response.data, error => self.$q.reject(error));
    }

    changePassword(changePasswordData) {
        let self = this;
        return this.$http({
            method: 'POST',
            url: this.getRoot() + '/user/change-password',
            headers: {
                'Content-Type': 'application/json'
            },
            data: changePasswordData
        }).then((response) => response.data, error => self.$q.reject(error));

    }

    loginOrRegister(isGoogle, loginData, token) {
        if(isGoogle) {
            if (token) {
              this.token = token
            } else {
              this.token = false
            }
            this.client.requestCode()
        } else {
            if (token) {
                return this.register({token: token, password: loginData.password}).then(() => this.$window.location.href = '/login?accepted=1');
            } else {
                return this.loginWithoutGoogle(loginData);
            }
        }
    }

    loginWithoutGoogle(loginData) {
        const authData = this.encode(loginData.username + ':' + loginData.password);
        return this.$http({
            method: 'POST',
            url: this.getRoot() + '/auth',
            headers: {
                'Authorization': 'Basic ' + authData,
                'Content-Type': 'application/json'
            },
            data: {}
        }).then((response) => {
            if (response.data.email !== undefined && response.data.token !== undefined) {
                localStorage.setItem('kes_email', response.data.email);
                localStorage.setItem('kes_token', response.data.token);
                this.$window.location.href = '/';
            } else {
                this.dialog.show(this.dialog.alert({
                    title: 'Login error',
                    textContent: 'You are not allowed to login to the system',
                    ok: 'ok',
                }));
            }
        }, () => {
            return this.$q.reject();
        });
    }

    loginWithGoogle(res) {
        this.$http({
            method: 'POST',
            url: this.getRoot() + '/auth',
            headers: {
                'Content-Type': 'application/json'
            },
            data: {code: res.code},
        }).then((response) => {
            if (response.data.email !== undefined && response.data.token !== undefined) {
                localStorage.setItem('kes_email', response.data.email);
                localStorage.setItem('kes_token', response.data.token);
                this.$window.location.href = '/';
            } else {
                this.dialog.show(this.dialog.alert({
                    title: 'Login error',
                    textContent: 'You are not allowed to login to the system',
                    ok: 'ok',
                }));
            }
        }).catch((response) => {
            return this.$q.reject(response);
        });
    }

    logout() {
        localStorage.removeItem('kes_email');
        localStorage.removeItem('kes_token');
        this.$window.location.href = '/login';
    }

    encode(input) {
        let keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        let output = "";
        let chr1, chr2, chr3 = "";
        let enc1, enc2, enc3, enc4 = "";
        let i = 0;

        do {
            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);

            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;

            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }

            output = output +
                keyStr.charAt(enc1) +
                keyStr.charAt(enc2) +
                keyStr.charAt(enc3) +
                keyStr.charAt(enc4);
            chr1 = chr2 = chr3 = "";
            enc1 = enc2 = enc3 = enc4 = "";
        } while (i < input.length);

        return output;
    }
}

export default AuthService;


// WEBPACK FOOTER //
// ./src/app/services/authService.js